/**
 * GSC ERROR TAXONOMY
 * Structured error classes for precise UI feedback.
 */

export class NeuralAPIError extends Error {
    constructor(message: string, public originalError?: unknown) {
        super(message);
        this.name = "NeuralAPIError";
    }
}

export class DSPError extends Error {
    constructor(message: string, public code?: string) {
        super(message);
        this.name = "DSPError";
    }
}

export class IntegrityError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "IntegrityError";
    }
}
